export enum AgencyTheme {
  Primary = 0,
  Secondary = 1,
  Third = 3,
  Dark = 4,
  Indigo = 5,
  Ocean = 6,
  Night = 7,
  Platinum = 8,
  Iron = 9,
  Ukraine = 10,
  BTIS = 11,
}

export const ThemeOptions = [
  { label: 'Primary', value: AgencyTheme.Primary.toString() },
  { label: 'Secondary', value: AgencyTheme.Secondary.toString() },
  { label: 'Third', value: AgencyTheme.Third.toString() },
  { label: 'Dark', value: AgencyTheme.Dark.toString() },
  { label: 'Indigo', value: AgencyTheme.Indigo.toString() },
  { label: 'Ocean', value: AgencyTheme.Ocean.toString() },
  { label: 'Night', value: AgencyTheme.Night.toString() },
  { label: 'Platinum', value: AgencyTheme.Platinum.toString() },
  { label: 'Iron', value: AgencyTheme.Iron.toString() },
  { label: 'Ukraine', value: AgencyTheme.Ukraine.toString() },
  { label: 'BTIS', value: AgencyTheme.BTIS.toString() },
];
